<template>
  <popper
    :trigger="triggerType"
    :options="{
      placement: positionType,
      modifiers: { offset: { offset: '0,5px' } },
    }"
  >
    <div class="popper p-2 rounded-0 shadow-sm border">
      {{ content }}
    </div>
    <div slot="reference">
      <slot />
    </div>
  </popper>
</template>

<script>
import { computed } from "@vue/composition-api";
import Popper from "@/components/display/Popper";

export default {
  name: "Tooltip",
  components: { Popper },
  props: {
    content: {
      type: String,
      default: null,
    },
    trigger: {
      type: String,
      default: "hover",
    },
    position: {
      type: String,
      default: "right",
    },
  },
  setup(props) {
    const positionList = {
      left: "left",
      right: "right",
      top: "top",
      bottom: "bottom",
    };
    const positionType = computed(() => {
      return positionList[props.position];
    });
    const triggerList = {
      hover: "hover",
      click: "clickToOpen",
      toggle: "clickToToggle",
    };
    const triggerType = computed(() => {
      return triggerList[props.trigger];
    });

    return {
      positionType,
      triggerType,
    };
  },
};
</script>
